import React, { Component } from 'react';
import PropTypes from 'prop-types';

// TODO: use debounce instead of throttle?
import { throttle } from 'throttle-debounce';

import AutocompleteField from '../AutocompleteField';
import { fetchLicenseResults } from './api';

export class LicenseField extends Component {
  throttleDelay = 500

  fetchLicenseResults = throttle(this.throttleDelay, async (value) => {
    const items = value ? await fetchLicenseResults(value) : [];
    this.setState({ items });
  })

  static propTypes = {
    /**
     * Connects your input component to Redux whose props are destructured into
     * your `<input/>` component.
    */
    input: PropTypes.shape({
      autoFocus: PropTypes.bool,
      placeholder: PropTypes.string,
    }).isRequired,

    onChange: PropTypes.func.isRequired,
    // onSelect: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  }

  state = {
    items: [],
  }

  handleChange = (event) => {
    const { onChange } = this.props;
    const { value } = event.target;
    onChange(value);
    this.fetchLicenseResults(value);
  }

  handleSelect = (value) => {
    const { onChange } = this.props;
    onChange(value);

    // use this.props.onSelect if we need to start patching something more complicated
  }

  getItemValue = (item) => item.name

  render() {
    const { input, value, ...rest } = this.props;
    const { items } = this.state;

    return (
      <div className="LicenseField">
        <AutocompleteField
          getItemValue={this.getItemValue}
          items={items}
          renderItem={(item, isHighlighted) => (
            <div className={`item ${isHighlighted ? 'item_highlighted' : ''}`} key={item.id}>
              {item.name}
            </div>
          )}
          autoHighlight
          onChange={this.handleChange}
          onSelect={this.handleSelect}
          renderMenu={(menuItems) => <div className="menu">{menuItems}</div>}
          // override id if passed one in
          inputProps={{ ...rest, id: 'LabeledField_License', ...input }}
          value={value}
          wrapperStyle={{}}
        />
      </div>
    );
  }
}

export default LicenseField;
